export default __webpack_public_path__ + "static/media/imagePlaceholder.0d910c58.svg";